import {
  ESTADOS_LLAMADAS_CHOICE,
  EstadosLlamadaEnumChoice,
  formatDate,
  gridSizeMdLg12,
  gridSizeMdLg3,
  gridSizeMdLg6,
} from "@/shared";
import {
  CustomAutocomplete,
  LoaderComponent,
  SampleCheckbox,
} from "@/shared/components/ui";
import {
  CitiesDataPagingRes,
  City,
  CondicionVentaCorporativa,
  Province,
  ProvincesDataPagingRes,
  Sector,
  TipoPlanCorporativo,
} from "@/shared/interfaces";
import {
  CustomAutocompleteArrString,
  CustomTextArea,
  CustomTextAreaNoForm,
  CustomTextField,
  CustomTextFieldNoForm,
  TabTextLabel,
} from "@/shared/components/ui";
import { SectorsPagingRes } from "@/shared/interfaces";
import { Grid } from "@mui/material";
import {
  FormAgendaCorporativo,
  IVentaCorporativoNoc,
} from "./SaveAgendamientoNoc";
import { UseFormReturn } from "react-hook-form";
import CustomCoordendasForm from "@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/CustomCoordendasForm";
import CalendarioAgendaNoc from "../../agendamientonoc/shared/components/calendario_agenda_noc/CalendarioAgendaNoc";
import { ApiResponse } from "@/shared/interfaces/erp/global/response-axios.interface";

interface TabInformacionAgendaNocProps {
  noForm: IVentaCorporativoNoc | null;
  /** Factibilidad corporativa (trae observaciones del asesor: vendedor/prefactibilidad/factibilidad). */
  factibilidadCorporativa?: any;
  form: UseFormReturn<FormAgendaCorporativo, any, FormAgendaCorporativo>;
  isLoadingSectors: boolean;
  sectorsByZonePaging?: SectorsPagingRes;
  provinceByCountry: ProvincesDataPagingRes | undefined;
  isLoadingProvinceByCountry: boolean;
  citiesByProvince: ApiResponse<CitiesDataPagingRes> | undefined;
  isLoadingCities: boolean;
}

export default function TabInformacionAgendaNoc({
  noForm,
  factibilidadCorporativa,
  form,
  isLoadingSectors,
  sectorsByZonePaging,
  provinceByCountry,
  isLoadingProvinceByCountry,
  citiesByProvince,
  isLoadingCities,
}: TabInformacionAgendaNocProps) {
  const {
    control,
    formState: { errors },
  } = form;

  return (
    <>
      <Grid container spacing={3}>
        {/*=====================INFORMACION GENERAL========================*/}
        <Grid item xs={12}>
          <TabTextLabel text="Información General" mt={0} pb={0} pl={0} />
        </Grid>

        <CustomTextFieldNoForm
          disabled={true}
          label={"Tipo de identificación"}
          defaultValue={noForm?.tipo_identificacion || ""}
          value={noForm?.tipo_identificacion || ""}
          size={gridSizeMdLg6}
        />
        <CustomTextFieldNoForm
          disabled={true}
          label={"No. Identificacion"}
          defaultValue={noForm?.identificacion || ""}
          value={noForm?.identificacion || ""}
          size={gridSizeMdLg6}
        />

        <CustomTextFieldNoForm
          disabled={true}
          label={"Razon social"}
          defaultValue={noForm?.razon_social || ""}
          value={noForm?.razon_social || ""}
          size={gridSizeMdLg12}
        />

        <CustomTextAreaNoForm
          disabled={true}
          label={"Actividad economica principal"}
          defaultValue={noForm?.actividad_economica_principal || ""}
          value={noForm?.actividad_economica_principal || ""}
          size={gridSizeMdLg12}
          autoGrow
          maxRows={6}
        />

        {/*========== OBSERVACIONES DEL ASESOR (ahora visibles también en el Área de Fibra/NOC) ==========*/}
        <Grid item xs={12}>
          <TabTextLabel text="Observaciones del Asesor" mt={0} pb={0} pl={0} />
        </Grid>
        <CustomTextAreaNoForm
          disabled={true}
          shrink
          required={false}
          label={"Observación Vendedor"}
          value={
            factibilidadCorporativa?.preventa_corporativa_data?.observaciones?.observacion_vendedor
            || factibilidadCorporativa?.prospecto_corporativo_data?.observaciones?.observacion_vendedor
            || "N/A"
          }
          size={gridSizeMdLg12}
          autoGrow
          maxRows={14}
        />
        <CustomTextAreaNoForm
          disabled={true}
          shrink
          required={false}
          label={"Observación Prefactibilidad"}
          value={
            factibilidadCorporativa?.preventa_corporativa_data?.observaciones?.observacion_prefactibilidad
            || factibilidadCorporativa?.observaciones?.observacion_prefactibilidad
            || "N/A"
          }
          size={gridSizeMdLg12}
          autoGrow
          maxRows={14}
        />
        <CustomTextAreaNoForm
          disabled={true}
          shrink
          required={false}
          label={"Observación Factibilidad"}
          value={
            factibilidadCorporativa?.observaciones?.observacion_factibilidad
            || "N/A"
          }
          size={gridSizeMdLg12}
          autoGrow
          maxRows={14}
        />

        <Grid item xs={12}>
          <TabTextLabel text="Servicio" mt={0} pb={0} pl={0} />
        </Grid>

        <CustomTextFieldNoForm
          disabled={true}
          label={"Servicio"}
          defaultValue={noForm?.tipo_servicio || "SIN SELECCION"}
          value={noForm?.tipo_servicio || "SIN SELECCION"}
          size={gridSizeMdLg6}
        />

        <CustomTextFieldNoForm
          disabled={true}
          label={"Tipo de Contrato"}
          // defaultValue={noForm?.tipo_plan || ""}
          value={"CORPORATIVO"}
          size={gridSizeMdLg6}
        />

        <CustomTextFieldNoForm
          disabled={true}
          label={"Subtipo de Contrato"}
          defaultValue={noForm?.tipo_plan || ""}
          value={noForm?.tipo_plan || ""}
          size={gridSizeMdLg6}
        />

        <CustomTextFieldNoForm
          disabled={true}
          label={"Requiere Back Up"}
          value={noForm?.requiere_backup ? "SI" : "NO"}
          size={gridSizeMdLg6}
        />

        <CustomTextFieldNoForm
          disabled={true}
          label={"Tipo servicio backup"}
          defaultValue={noForm?.tipo_servicio_backup || "N/A"}
          value={noForm?.tipo_servicio_backup || "N/A"}
          size={gridSizeMdLg6}
        />
        <CustomTextFieldNoForm
          disabled={true}
          label={"Servicio ultima milla"}
          defaultValue={noForm?.servicio_ultima_milla || ""}
          value={noForm?.servicio_ultima_milla || ""}
          size={gridSizeMdLg6}
        />

        <Grid item container {...gridSizeMdLg12} spacing={3}>
          <Grid item container {...gridSizeMdLg12} spacing={3}>
            {/* <Grid container item>
              <Typography variant="h6">Detalles del Servicio</Typography>
            </Grid> */}
            <Grid item xs={12}>
              <TabTextLabel text="Detalles del Servicio" mt={0} pb={0} pl={0} />
            </Grid>

            <Grid
              item
              container
              spacing={3}
              {...gridSizeMdLg12}
              justifyContent={"start"}
              alignContent={"start"}
            >
              <CustomTextFieldNoForm
                value={
                  noForm?.data_plan_personalizado?.nombre_personalizado||"N/A"
                }
                size={gridSizeMdLg6}
                label={"Nombre de plan"}
                shrink={true}
                disabled={true}
              />
              <CustomTextFieldNoForm
                value={
                    noForm?.data_plan_personalizado?.tipo_plan_personalizado
                    || ""
                }
                size={gridSizeMdLg6}
                label={"Tipo de plan"}
                shrink={true}
                disabled={true}
              />
              <CustomTextFieldNoForm
                value={
                  noForm?.data_plan_personalizado?.permanencia_personalizado||"N/A"
                }
                size={gridSizeMdLg6}
                label={"Tiempo de Permanencia"}
                shrink={true}
                disabled={true}
              />
              <CustomTextFieldNoForm
                value={
                  noForm?.data_plan_personalizado?.capacidad_personalizado || "0"
                }
                size={gridSizeMdLg6}
                label={"Enlace (Mbps)"}
                shrink={true}
                disabled={true}
              />
              <CustomTextFieldNoForm
                value={
                  noForm?.data_plan_personalizado?.valor_personalizado ||"0"
                }
                size={gridSizeMdLg6}
                label={"Valor"}
                shrink={true}
                disabled={true}
              />
              <CustomTextFieldNoForm
                value={
                  noForm?.data_plan_personalizado?.costo_instalacion_personalizado || "0"
                }
                size={gridSizeMdLg3}
                label={`Valor Instalación ${
                  !noForm?.plan_personalizado ? "Referencial" : ""
                }`}
                shrink={true}
                disabled={true}
              />

              <CustomTextFieldNoForm
                value={
                  noForm?.data_plan_personalizado
                    ?.bonificacion_personalizado! || "0"
                }
                size={gridSizeMdLg6}
                label={"Bonificación (Mbps)"}
                disabled={true}
                shrink={
                  !!noForm?.data_plan_personalizado?.bonificacion_personalizado!
                }
              />
              <CustomTextFieldNoForm
                label={"Velocidad Total"}
                // name="velocidad_total"
                // defaultValue={noForm?.data_plan_personalizado?. ||"0"}
                value={
                  parseFloat(
                    noForm?.data_plan_personalizado?.capacidad_personalizado ||
                      "0"
                  ) +
                    (noForm?.data_plan_personalizado
                      ?.bonificacion_personalizado || 0) || "0"
                }
                size={gridSizeMdLg6}
                shrink={!!noForm?.velocidad_total}
                // control={control}
                // error={errors.velocidad_total}
                // helperText={errors?.velocidad_total?.message}
                disabled={true}
              />
              <CustomTextFieldNoForm
                label={"Disponibilidad"}
                // name="disponibilidad"
                value={noForm?.disponibilidad || "0"}
                size={gridSizeMdLg6}
                shrink={true}
                // control={control}
                // error={form.formState.errors.disponibilidad}
                // helperText={form.formState?.errors?.disponibilidad?.message}
                disabled={true}
              />
              {noForm?.tipo_plan == TipoPlanCorporativo.DEMO ? (
                <SampleCheckbox
                  label="Requiere Backup"
                  control={form.control}
                  name="requiere_backup"
                  defaultValue={noForm?.requiere_backup || false}
                  // onChangeValue={(e) => {
                  //   form.reset({ ...form.getValues(), requiere_backup: e })
                  // }}
                  size={gridSizeMdLg6}
                  disabled
                />
              ) : null}
            </Grid>
            {(noForm?.prospecto_corporativo_data?.condicion_venta ==
              CondicionVentaCorporativa.EVENTO_GRATUITO ||
              noForm?.prospecto_corporativo_data?.condicion_venta ==
                CondicionVentaCorporativa.EVENTO_PAGADO) &&
            noForm?.tipo_plan == TipoPlanCorporativo.DEMO ? (
              <Grid
                item
                container
                spacing={2}
                justifyContent={"start"}
                alignContent={"start"}
                {...gridSizeMdLg12}
              >
                <CustomTextFieldNoForm
                  label={"Fecha de Inicio Plan"}
                  value={formatDate(noForm?.fecha_inicio_plan || "") || "0"}
                  size={gridSizeMdLg6}
                  shrink={true}
                  disabled={true}
                />
                <CustomTextFieldNoForm
                  label={"Fecha de Fin Plan"}
                  value={formatDate(noForm?.fecha_fin_plan || "") || "0"}
                  size={gridSizeMdLg6}
                  shrink={true}
                  disabled={true}
                />
              </Grid>
            ) : null}

            <Grid
              item
              container
              spacing={3}
              {...gridSizeMdLg12}
              justifyContent={"start"}
              alignContent={"start"}
            ></Grid>
          </Grid>
        </Grid>

        {/* <CustomTextFieldNoForm
          disabled={true}
          label={'Tipo servicio contratar'}
          defaultValue={noForm?.tipo_servicio_contratar || ''}
          value={noForm?.tipo_servicio_contratar || ''}
          size={gridSizeMdLg6}
        /> */}


        {/*=====================ESTADO DE LLAMADA========================*/}

        <Grid item xs={12}>
          <TabTextLabel text="ESTADO DE LLAMADA" mt={0} pb={0} pl={0} />
        </Grid>
        <CustomTextField
          size={gridSizeMdLg6}
          type="number"
          control={form.control}
          name="celular_1"
          label={"Celular 1"}
          error={errors.celular_1}
          defaultValue={form.getValues().celular_1 || ""}
          helperText={form.formState.errors.celular_1?.message}
        />

        <CustomTextField
          size={gridSizeMdLg6}
          type="number"
          control={form.control}
          name="celular_2"
          label={"Celular 2"}
          error={errors.celular_2}
          defaultValue={noForm?.celular_2 || ""}
          helperText={form.formState.errors.celular_2?.message}
        />

        <CustomAutocompleteArrString
          label="Estado de la llamada"
          name="estado_llamada"
          control={form.control}
          defaultValue={form.getValues().estado_llamada || ""}
          options={ESTADOS_LLAMADAS_CHOICE.filter(
            (el) => el !== EstadosLlamadaEnumChoice.EN_ESPERA
          )}
          isLoadingData={false}
          error={errors.estado_llamada}
          helperText={errors.estado_llamada?.message}
          disableClearable
        />

        <CustomTextArea
          label="Observación Llamada"
          name="observacion_llamada"
          control={form.control}
          defaultValue={form.getValues().observacion_llamada || ""}
          error={errors.observacion_llamada}
          helperText={errors.observacion_llamada?.message}
          required={false}
        />

        {/*=====================UBICACION========================*/}
        <Grid item xs={12}>
          <TabTextLabel text="Ubicación" mt={0} pb={0} pl={0} />
        </Grid>

        <CustomCoordendasForm
          form={form}
          label="Coordendas Fusión"
          name="coordenada_fusion"
          defaultValue={form.watch().coordenada_fusion}
          enableLocationOnChange={true}
          key={"key_coordenada_fusion"}
        />

        <CustomCoordendasForm
          form={form}
          label="Coordendas Empresa"
          name="coordenada_empresa"
          defaultValue={form.watch().coordenada_empresa}
          enableLocationOnChange={true}
          key={"key_coordenada_empresa"}
        />

        <CustomCoordendasForm
          form={form}
          label="Coordendas Servicio"
          name="coordenada_servicio"
          defaultValue={form.watch().coordenada_servicio}
          key={"key_coordenada_servicio"}
          size={gridSizeMdLg12}
          enableLocationOnChange={true}
        />

        <CustomTextField
          control={form.control}
          name="direccion_servicio"
          label={"Dirección servicio"}
          error={form.formState.errors.direccion_servicio}
          defaultValue={form.getValues().direccion_servicio || ""}
          helperText={form.formState.errors.direccion_servicio?.message}
        />

        {form.getValues().zona_nombre &&
        form.getValues().provincia_nombre &&
        form.getValues().ciudad_nombre ? (
          <Grid item container spacing={3} {...gridSizeMdLg12}>
            <TabTextLabel
              text="Ingrese las coordenadas de servicio para obtener los datos posteriores."
              pb={"0px"}
            />
            {isLoadingSectors ? (
              <LoaderComponent />
            ) : (
              <>
                <CustomTextField
                  control={control}
                  name="provincia_nombre"
                  defaultValue={form.getValues().provincia_nombre}
                  size={gridSizeMdLg6}
                  label={"Provincia"}
                  error={errors.provincia_nombre}
                  helperText={errors.provincia_nombre?.message}
                  disabled={true}
                />
                <CustomTextField
                  control={control}
                  name="ciudad_nombre"
                  defaultValue={form.getValues().ciudad_nombre}
                  size={gridSizeMdLg6}
                  label={"Ciudad"}
                  error={errors.ciudad_nombre}
                  helperText={errors.ciudad_nombre?.message}
                  disabled={true}
                />

                {/* <CustomTextField
                      control={control}
                      name="zona_nombre"
                      defaultValue={form.getValues().zona_nombre}
                      size={gridSizeMdLg6}
                      label={'Zona_nombre'}
                      error={errors.zona_nombre}
                      helperText={errors.zona_nombre?.message}
                      disabled={true}
                    /> */}

                <CustomAutocomplete<Sector>
                  size={gridSizeMdLg6}
                  label={"Sector"}
                  name="sector"
                  options={sectorsByZonePaging?.data || []}
                  defaultValue={form.watch().sector}
                  isLoadingData={false}
                  control={form.control}
                  error={errors.sector}
                  helperText={errors.sector?.message}
                  valueKey="alias" // name is the fk
                  actualValueKey="codigo"
                  //disabled={disabledAll}
                />
              </>
            )}
          </Grid>
        ) : (
          <Grid item container spacing={3} {...gridSizeMdLg12}>
            <TabTextLabel
              text="No existe cobertura en las coordenadas ingresadas. Ingrese manualmente los datos."
              pb={"0px"}
            />
            <CustomAutocomplete<Province>
              size={gridSizeMdLg6}
              label={"Provincia"}
              name="provincia"
              options={provinceByCountry?.data || []}
              defaultValue={form.watch().provincia}
              isLoadingData={isLoadingProvinceByCountry}
              control={form.control}
              error={errors.provincia}
              helperText={errors.provincia?.message}
              valueKey="nombre" // name is the fk
              actualValueKey="codigo"
              //disabled={disabledAll}
              /* onChangeValue={(e) => {
                  setSelectedProvince(e)
                }} */
            />
            <CustomAutocomplete<City>
              size={gridSizeMdLg6}
              label={"Ciudad"}
              name="ciudad"
              options={citiesByProvince?.data?.data || []}
              defaultValue={form.watch().ciudad}
              isLoadingData={isLoadingCities}
              control={form.control}
              error={errors.ciudad}
              helperText={errors.ciudad?.message}
              valueKey="nombre" // name is the fk
              actualValueKey="codigo"
              //disabled={disabledAll}
              /* onChangeValue={(e) => {
                  setSelectedCity(e)
                }} */
            />
            <CustomTextField
              control={control}
              name="sector_tentativo"
              defaultValue={form.getValues().sector_tentativo}
              size={gridSizeMdLg6}
              label={"Sector"}
              error={errors.sector_tentativo}
              helperText={errors.sector_tentativo?.message}
            />
          </Grid>
        )}

        {/* <CustomTextFieldNoForm
          disabled={true}
          label={'País'}
          defaultValue={noForm?.pais || ''}
          value={noForm?.pais || ''}
          size={gridSizeMdLg6}
        />

        <CustomTextFieldNoForm
          disabled={true}
          label={'Provincia'}
          defaultValue={form.getValues().provincia_nombre || ''}
          value={form.getValues().provincia_nombre || ''}
          size={gridSizeMdLg6}
        />

        <CustomTextFieldNoForm
          disabled={true}
          label={'Ciudad'}
          defaultValue={form.getValues().ciudad_nombre || ''}
          value={form.getValues().ciudad_nombre || ''}
          size={gridSizeMdLg6}
        />

        <CustomTextFieldNoForm
          disabled={true}
          label={'Zona'}
          defaultValue={form.getValues().zona_nombre || ''}
          value={form.getValues().zona_nombre || ''}
          size={gridSizeMdLg6}
        /> */}

        {/* {
          isLoadingSectors ?
            <Grid item {...gridSizeMdLg12} textAlign={'center'}>
              <CircularProgress />
            </Grid>
            :
            <CustomAutocomplete<Sector>
              size={gridSizeMdLg6}
              label={"Sector"}
              name="sector"
              options={sectorsByZonePaging?.data || []}
              defaultValue={form.getValues().sector}
              isLoadingData={false}
              control={form.control}
              error={errors.sector}
              helperText={errors.sector?.message}
              valueKey="alias" // name is the fk
              actualValueKey="codigo"
              disabled={false}
            />
        } */}

        {/*=====================ACTUALIZAR HORARIOS========================*/}

        <Grid item xs={12}>
          <TabTextLabel text="SELECCIONAR TÉCNICO" mt={0} pb={0} pl={0} />
        </Grid>

        <CalendarioAgendaNoc cacheKey="calendario-noc" form={form} />
      </Grid>
    </>
  );
}
